
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"11","height":"9","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.54 8.203a3.77 3.77 0 01-.907.125 2.466 2.466 0 01-1.742-.695c-.495-.464-.972-1.2-1.43-2.211-.51.864-1.01 1.487-1.5 1.867-.484.38-1.016.57-1.594.57-.495 0-.935-.15-1.32-.453-.38-.302-.675-.71-.883-1.226A4.715 4.715 0 01.86 4.453c0-.64.115-1.229.344-1.766.23-.541.54-.958.93-1.25.39-.296.828-.445 1.312-.445.412 0 .774.08 1.086.242.318.157.623.404.914.743.297.338.636.83 1.016 1.476a11.82 11.82 0 011.016-1.648c.333-.438.682-.758 1.046-.961C8.893.635 9.34.53 9.86.53c.26 0 .485.024.672.07l-.25 1.212a2.67 2.67 0 00-.437-.04c-.354 0-.672.081-.953.243-.276.161-.56.427-.852.796-.286.37-.633.912-1.039 1.626.255.494.503.919.742 1.273.245.349.477.622.696.82.223.193.447.336.671.43.224.088.472.133.743.133.161 0 .302-.01.421-.032l.266 1.141zM5.921 4.438c-.458-.797-.88-1.365-1.266-1.704-.385-.338-.789-.507-1.21-.507-.308 0-.587.078-.837.234-.244.156-.44.398-.586.727-.145.322-.218.723-.218 1.203 0 .526.075.958.226 1.296.156.339.357.581.602.727.245.14.515.211.812.211.448 0 .873-.177 1.274-.531.406-.36.807-.912 1.203-1.657z","fill":"currentColor"}})])
          )
        }
      }
    